import { HttpErrorResponse, HttpEvent, HttpHandler, HttpInterceptor, HttpRequest, HttpResponseBase } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { EnvConfig } from '@core/config';
import { AppStoreQuery, AppStoreService } from '@core/state';
import { isInternalApi } from '@core/utils';
import { SnackBarService } from '@feature/snack-bar/snack-bar.service';
import { loginAbsoluteRoute } from '@shared/shared-routes';
import { throwError, Observable } from 'rxjs';
import { catchError, map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationInterceptor implements HttpInterceptor {
  constructor(
    private env: EnvConfig,
    private query: AppStoreQuery,
    private router: Router,
    private store: AppStoreService,
    private snackBarService: SnackBarService,
  ) {}

  public intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const token = this.query.getAuthenticationToken();

    if (
      token &&
      // do not leak the token to the outside world
      isInternalApi(request.url, this.env.apiUrl)
    ) {
      request = request.clone({
        headers: request.headers.set('X-API-Token', token),
      });
    }

    return next.handle(request).pipe(
      map((event: HttpEvent<HttpResponseBase>) => event),
      catchError((error: Error) => {
        if (error instanceof HttpErrorResponse) {
          try {
            if (error.status === 401) {
              const isManualLogout = localStorage.getItem('wai_logout_reason') === 'manual';
              // Use setTimeout to break potential circular dependency timing issues
              setTimeout(() => {
                this.store.reset();
                if (!isManualLogout) {
                  this.snackBarService.error('INTL_AUTOMATED_LOGOUT');
                }
                if (!isManualLogout && !this.router.url.includes('reset')) {
                  this.router.navigate([loginAbsoluteRoute]);
                }
              }, 0);
            }
          } catch (e) {
            setTimeout(() => {
              this.snackBarService.error('INTL_ERROR', e);
            }, 0);
          }
        }
        return throwError(error);
      }),
    );
  }
}
